import {
  PaginationProvider,
  SearchProvider,
} from 'dash-ui';

import { GetPropertyByIdQuery } from 'gql/generated.graphql';

import FeaturesAndAmenities from './components/FeaturesAndAmenities/FeaturesAndAmenities';

function PropertyFeaturesAndAmenitiesTab({
  property,
}: {
  property: GetPropertyByIdQuery['getPropertyById'];
}) {
  return (
    <PaginationProvider>
      <SearchProvider>
        <FeaturesAndAmenities property={property} />
      </SearchProvider>
    </PaginationProvider>
  );
}

export default PropertyFeaturesAndAmenitiesTab;
